/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_A2Inputs */

const en_to_typescript_faq_a2 = /** @type {(inputs: To_Typescript_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The root interface is named RootObject. Rename it after copying into your project, along with any nested interface names you want to change.`)
};

const ko_to_typescript_faq_a2 = /** @type {(inputs: To_Typescript_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`루트 인터페이스 이름은 RootObject입니다. 프로젝트에 복사한 뒤, 바꾸고 싶은 중첩 인터페이스 이름과 함께 이름을 변경하세요.`)
};

const ja_to_typescript_faq_a2 = /** @type {(inputs: To_Typescript_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ルートインターフェースの名前は RootObject です。プロジェクトにコピーした後で、変えたいネストしたインターフェース名とあわせて改名してください。`)
};

/**
* | output |
* | --- |
* | "The root interface is named RootObject. Rename it after copying into your project, along with any nested interface names you want to change." |
*
* @param {To_Typescript_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_a2 = /** @type {((inputs?: To_Typescript_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_a2(inputs)
	if (locale === "ko") return ko_to_typescript_faq_a2(inputs)
	return ja_to_typescript_faq_a2(inputs)
});